<template>
	<section class="modal-card-body">
		<div class="columns">
			<custom-invoice-settings></custom-invoice-settings>
		</div>
		<div class="columns">
			<custom-invoice-sales-table></custom-invoice-sales-table>
		</div>
		<div class="columns">
			<custom-invoice-dates></custom-invoice-dates>
			<custom-invoice-sub-total></custom-invoice-sub-total>
		</div>
		<div class="columns">
			<custom-invoice-costs-table></custom-invoice-costs-table>
		</div>
		<div class="columns">
			<custom-invoice-in-charge></custom-invoice-in-charge>
			<custom-invoice-total></custom-invoice-total>
		</div>
	</section>
</template>

<script>
	import CustomInvoiceSettings from './CustomInvoiceSettings'
	import CustomInvoiceDates from './CustomInvoiceDates'
	import CustomInvoiceSubTotal from './CustomInvoiceSubTotal'
	import CustomInvoiceCostsTable from './CustomInvoiceCostsTable'
    import CustomInvoiceSalesTable from './CustomInvoiceSalesTable'
	import CustomInvoiceInCharge from './CustomInvoiceInCharge'
	import CustomInvoiceTotal from './CustomInvoiceTotal'
    export default {
        components: {
            CustomInvoiceSettings,
            CustomInvoiceDates,
            CustomInvoiceSubTotal,
            CustomInvoiceCostsTable,
            CustomInvoiceSalesTable,
            CustomInvoiceInCharge,
            CustomInvoiceTotal
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceBody.vue